import { apiFetch, apiJson } from './api';

export type Characteristics = Record<string, string>;

export type Hero = {
  id: number;
  name: string;
  photo: string;
  characteristics: Characteristics;
  created_at: string;
};

export function listHeroes(): Promise<Hero[]> {
  return apiJson<Hero[]>('/api/heroes/');
}

export function createHero(name: string, photo: File): Promise<Hero> {
  const body = new FormData();
  body.append('name', name);
  body.append('photo', photo);
  return apiJson<Hero>('/api/heroes/', { method: 'POST', body });
}

export function renameHero(id: number, name: string): Promise<Hero> {
  const body = new FormData();
  body.append('name', name);
  return apiJson<Hero>(`/api/heroes/${id}/`, { method: 'PATCH', body });
}

export function updateCharacteristics(
  id: number,
  characteristics: Characteristics,
): Promise<Hero> {
  return apiJson<Hero>(`/api/heroes/${id}/characteristics/`, {
    method: 'PUT',
    body: JSON.stringify({ characteristics }),
  });
}

export async function deleteHero(id: number): Promise<void> {
  // The endpoint returns 204 No Content, so don't try to parse a body.
  await apiFetch(`/api/heroes/${id}/`, { method: 'DELETE' });
}
